/* eslint-disable @typescript-eslint/no-misused-promises, no-void */
import React, { useEffect } from "react";
import useHeaderStore from "../../../../store/layout/headerStore";
import WorkspaceMembersPage from "../workspace-members/WorkspaceMembersPage";
import WorkspaceSettingsPage from "./WorkspaceSettingsPage";

type TabValue = "workspace" | "members";

type Props = {
  initialTab?: TabValue;
};

const WorkspaceSettingsHubPage: React.FC<Props> = ({ initialTab = "workspace" }) => {
  const { setHeaderContent, resetHeader } = useHeaderStore();

  useEffect(() => {
    resetHeader();
    setHeaderContent({
      title: initialTab === "workspace" ? "Workspace Settings" : "Workspace Members",
      description:
        initialTab === "workspace"
          ? "Manage your workspace settings"
          : "Manage who has access to this workspace",
    });

    return () => resetHeader();
  }, [initialTab, resetHeader, setHeaderContent]);

  return (
    <div className="mx-auto max-w-5xl px-4 py-4">
      {initialTab === "workspace" ? <WorkspaceSettingsPage embedded /> : <WorkspaceMembersPage embedded />}
    </div>
  );
};

export default WorkspaceSettingsHubPage;
